
import Header from '~/components/layouts/Header.vue';
import WidgetAdmin from '~/node_modules/sitis-nuxt/components/widget-admin/WidgetAdmin.vue';
import {
  AppMixin,
  UserMixin,
  CmsMetaMixin,
  UserAuthMixin
} from '~/node_modules/sitis-nuxt/lib/mixins';
import {metaData} from '~/helpers/meta-data';

let timeOutFeedbackFormTime = null;
export default {
  name: 'LayoutDefault',

  data: function () {
    return {
      fetchHost: '',
    };
  },

  mixins: [
    AppMixin,
    UserMixin,
    UserAuthMixin,
    CmsMetaMixin
  ],

  computed: {
    canonicalLinks() {
      let path = ((this.$route.path || '').split('/f/')?.[0] || '').split('?')?.[0] || '';
      if (path.charAt(path.length - 1) === '/') {
        path = path.slice(0, -1);
      }
      return [{rel: 'canonical', href: `https://${this.fetchHost}${path}`}];
    },
    headerMetaAsync() {
      const config = this.$store.state?.appState?.config;
      const headMeta = config?.head?.meta || [];
      const cityName = this.$store.state?.appState?.config?.city?.data?.city_name;
      const pageTitle = [
        this?.page?.page?.title,
        config?.suffixDivider,
        config?.suffixTitle,
      ].filter((t) => !!t).join(' ');

      let meta = [];

      headMeta.forEach((item) => {
        meta.push(
          {name: item.name, content: item.content},
        );
      });

      meta = [
        ...meta,
        ...metaData({
          logoLink: this?.appCfg?.logoFront || '',
          pageSlug: this.$route.fullPath || '',
          pageTitle: pageTitle || '',
          pageDescription: this?.page?.page?.description || '',
          cityName: cityName,
          host: this.fetchHost || window?.location?.host,
        }),
      ];

      return meta;
    },
    titleTemplate: function () {
      const {
        suffixDivider,
        suffixTitle,
      } = this.$store.state?.appState?.config || {};

      const template = [suffixDivider, suffixTitle].filter((t) => !!t).join(' ');

      return `%s ${template}`;
    },
    isPopUpImagesZoom: function () {
      return this.$store.state['pop-up-images-zoom'].isOpen;
    },
  },

  components: {
    BackCall: () => import('~/components/layouts/BackCall.vue'),
    PopUpImages: () => import('~/components/layouts/PopUpImages'),
    PopUpVideo: () => import('~/components/layouts/PopUpVideo.vue'),
    PopUpLoading: () => import('~/components/layouts/PopUpLoading.vue'),
    BackCallCustom: () => import('~/components/layouts/BackCallCustom.vue'),
    PopUpImagesZoom: () => import('~/components/layouts/PopUpImagesZoom.vue'),
  },

  async fetch() {
    this.$device();
    this.fetchHost = this.$parent?.context?.req?.headers?.host;
  },

  head() {
    const meta = this.headerMetaAsync;
    const cityName = this.$store.state?.appState?.config?.city?.data?.prepositional || this.$store.state?.appState?.config?.city?.data?.city_name;
    const canonical = this.canonicalLinks;

    return {
      title: `Транспортная компания в ${cityName} - Central Trans`,
      meta: [...meta],
      titleTemplate: this.titleTemplate,
      link: [...canonical],
    };
  },

  async mounted() {
    this.checkSubDomain();
    await this.$store.dispatch("authRegistration/getUserTransportation")
  },

  methods: {
    checkSubDomain: function () {
      let host = window?.location?.host || '';
      const cityName = this.$store.state?.appState?.config?.city?.model?.name || '';
      if (!!cityName || host.indexOf('localhost') > -1) {
        return;
      }

      host = host.split('.');
      if (host.length === 3) {
        host.shift();
      }
      host = host.join('.');
      window.location.host = host;
    },
  },
};
